import React from 'react';

export const KovLegal = ({ item, children }) => {
  return (
    <p className="kov-legal regelgeving">
      <a>{item.identifier}</a>

      {children}
    </p>
  );
};

export default KovLegal;
